import React, {Component} from "react";
import {Link} from "react-router-dom";
import EventHelper from "../../../helpers/EventHelper";
import Timer from "../../../../assets/images/timer.svg";

class LiveEvent extends Component {
	render() {
		const {event, results, isChecked, checkHandler} = this.props;
		const {id, team1, team2} = event;
		const result = EventHelper.parseResults(results);
		const timer = result.minute !== 0 ? <span className="timer"><img src={Timer} />{result.minute}''</span> : '';

		return (
			<div className="tbody">
				<div className="tr">
					<div className="td favorite">
						<div className="checkbox">
							<input type="checkbox" id={id} value={id} onChange={checkHandler} checked={isChecked}/>
							<label htmlFor={id}/>
						</div>
					</div>
					<div className="td players">
						<Link to={`/live/${id}`}>{team1} - {team2}</Link>
					</div>
					<div className="td score">
						{result.score}
						{timer}
					</div>
				</div>
			</div>
		);
	}
}

export default LiveEvent;


// WEBPACK FOOTER //
// ./src/app/pages/Live/modules/LiveEvent.js